/****************************************************
 * Module Name:  documentTypeProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class DocumentTyeProxy {
    static getAllDocumentType = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/doctype",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0)
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    }

    static CheckDocumentTypeAvailable = (documentType, callback) => {
        let params = {
            type: documentType,
        };

        restAPICall(
            Constants.MANAGER_URL + "/doctype/available",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddDocumentType = (documentType, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/doctype",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(documentType),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateDocumentType = (documentType, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/doctype",
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(documentType),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}
